exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".touchpoint-info[data-v-59fadbca]{position:absolute;padding-right:30px;right:0;min-width:700px;width:50%;height:600px;z-index:1 !important}.is-sticky .touchpoint-info[data-v-59fadbca]{right:39px;padding-right:1px}\n", ""]);

